export let __crud = {};
export let __vue = {};
export let __event = {};
export let __components = {};
export let __plugins = [];
